import React from 'react'
import '.././PopupCommonStyle.css'
import styles from './Style.module.css'
import { BtnPrimary } from '../../Buttons/BtnPrimary';
import { BtnSecondary } from '../../Buttons/BtnSecondary';
// import { BtnClose } from '../../Buttons/BtnClose/BtnClose';

export const ChangeOutletPopup = ({
  active,
  onClose,
  handleChangeOutlet,
}) => {
  return (
    <div className={`${styles.changeOutletPopup} popup ${active ? "show" : ""}`}>
        <div className={`${styles.popHeader} popup-header`}>
          {/* <BtnClose
            handleClick={onClose}
            title="Close"
            customClass="popup-exit-btn"
          /> */}
          <h2 className="title">Change Outlet?</h2>
          <h6 className="titleSub">Changing the outlet will clear your current booking selections because services and therapists availability may differ between outlets.</h6>
          <h6 className="titleSub">You'll need to select your services and appointment time again.</h6>
        </div>
        <div className={`popup-body`}></div>

        <div className={`${styles.footer} popup-footer`}>
          <BtnSecondary
            label="Cancel"
            handleClick={onClose}
            customClass="w-100 no-icon"
          />
          <BtnPrimary
            label="Change Outlet"
            handleClick={handleChangeOutlet}
            customClass="w-100 no-icon"
          />
        </div>
    </div>
  )
}
